import {
    getOriented,
    triageMyInbox,
    findQuickWins,
    inboxMorningBriefing,
    inboxEveningBriefing,
    generateProactiveDrafts,
    type Suggestions,
} from '../utils/suggestionCatalog';
import { isAccountFeatureEnabled } from 'owa-feature-flags';
import { shouldShowInboxBriefingsSUA } from 'owa-mail-inbox-briefings-utils/lib/utils/shouldShowInboxBriefingsSUA';
import { isMorningBriefing } from 'owa-mail-inbox-briefings-utils/lib/utils/currentTimeCheckUtils';
import type { MailboxInfo } from 'owa-client-types';

export function getEmptyReadingPaneSuggestions(mailboxInfo: MailboxInfo): Suggestions {
    const baseSuggestions: Suggestions = [triageMyInbox, getOriented, findQuickWins];

    if (shouldShowInboxBriefingsSUA()) {
        // Add inbox briefing as 1st suggestion and remove the last item to keep the number of suggestions at 3
        baseSuggestions.unshift(isMorningBriefing() ? inboxMorningBriefing : inboxEveningBriefing);
        baseSuggestions.pop();
    }

    // Add "Generate Proactive Drafts" suggestion if the experimental flag is enabled
    // NOTE: this is temporary, throwaway code, to be removed at a later date when the experiment is done
    if (isAccountFeatureEnabled('mon-copilot-proactive-drafts-experimental', mailboxInfo)) {
        // Append as the 4th suggestion instead of replacing an existing one
        baseSuggestions.push(generateProactiveDrafts);
    }

    return baseSuggestions;
}
